import { translations } from './translations'

let currentLanguage = 'es'

export function setLanguage(language: string) {
    currentLanguage = language
}

export function localize(key: string, ...args: any[]): string {
    let template = translations[currentLanguage]?.[key] || key

    // Replace %s placeholders with provided arguments
    return template.replace(/%s/g, () => args.shift() || '')
}

declare global {
    interface String {
        localized(...args: any[]): string
    }
}

String.prototype.localized = function(...args: any[]) {
    return localize(this.toString(), ...args)
}